import { financialConstants } from "@/actions/constants/financialConstants";
import type { FinancialView } from "@/actions/financialActions";

export interface FinancialState {
  loading: boolean;
  error: string | null;
  financialViewByEventId: Record<string, FinancialView>;
}

const initialState: FinancialState = {
  loading: false,
  error: null,
  financialViewByEventId: {},
};

const financialReducer = (
  state: FinancialState = initialState,
  action: any
): FinancialState => {
  switch (action.type) {
    case financialConstants.getFinancialRequest:
      return { ...state, loading: true, error: null };

    case financialConstants.getFinancialSuccess:
      return { ...state, loading: false, error: null };

    case financialConstants.getFinancialFailure:
      return { ...state, loading: false, error: action.payload };

    case financialConstants.setFinancialView:
      return {
        ...state,
        financialViewByEventId: {
          ...state.financialViewByEventId,
          [action.payload.eventId]: action.payload.view,
        },
      };

    case financialConstants.clearFinancialState:
      return { ...initialState, financialViewByEventId: state.financialViewByEventId };

    default:
      return state;
  }
};

export default financialReducer;

export const selectFinancialLoading = (state: any): boolean =>
  !!state?.financial?.loading;

export const selectFinancialError = (state: any): string | null =>
  state?.financial?.error || null;

export const selectFinancialView = (state: any, eventId: string): FinancialView =>
  state?.financial?.financialViewByEventId?.[eventId] || "summary";
